var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-select",
    {
      staticStyle: { width: "200px" },
      attrs: { "default-value": null },
      on: { change: _vm.handleChange },
    },
    _vm._l(_vm.templates, function (template) {
      return _c(
        "a-select-option",
        { key: template.id, attrs: { value: template.id } },
        [_vm._v("\n        " + _vm._s(template.name) + "\n    ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }